import React, { useState, useCallback } from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import { useTranslation } from 'react-i18next';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import NoteItem from './NoteItem';
import NoteForm from './NoteForm';
import financialNotesService from '../services/claim/financial_notes.service';
const NotesList = _ref => {
  let {
    notes,
    section,
    claim,
    setClaim
  } = _ref;
  const [loading, setLoading] = useState(false);
  const [newNote, setNewNote] = useState({
    content: '',
    section: section
  });
  const {
    t
  } = useTranslation();
  const handleNoteChange = e => {
    setNewNote({
      ...newNote,
      'content': e.target.value
    });
  };
  const addNote = useErrorHandling(useCallback(async () => {
    setLoading(true);
    const createdNote = await financialNotesService.create(claim.id, newNote);
    const updatedNotes = claim.financial_notes;
    updatedNotes.push(createdNote);
    setNewNote({
      content: '',
      section: section
    });
    setClaim({
      ...claim,
      financial_notes: updatedNotes
    });
    setLoading(false);
  }, [newNote]));
  const removeNote = useErrorHandling(useCallback(async noteId => {
    await financialNotesService.delete(claim.id, noteId);
    let updatedNotes = claim.financial_notes;
    updatedNotes = updatedNotes.filter(note => note.id !== noteId);
    setClaim({
      ...claim,
      financial_notes: updatedNotes
    });
  }, [claim]));
  const editNote = useErrorHandling(useCallback(async (note, index) => {
    const updatedNote = await financialNotesService.edit(claim.id, note);
    let updatedNotes = claim.financial_notes.filter(note => note.section === section);
    updatedNotes[index] = updatedNote;
    setClaim({
      ...claim,
      financial_notes: updatedNotes
    });
  }, [claim]));
  return /*#__PURE__*/React.createElement(React.Fragment, null, notes.map((note, index) => {
    return /*#__PURE__*/React.createElement(NoteItem, {
      removeNote: removeNote,
      note: note,
      editNote: editNote,
      index: index
    });
  }), /*#__PURE__*/React.createElement(NoteForm, {
    newNote: newNote,
    handleNoteChange: handleNoteChange,
    addNote: addNote,
    loading: loading
  }));
};
export default NotesList;